module.exports = __webpack_public_path__ + "img/2027_S.21dca23c.png";